// extracted by mini-css-extract-plugin
export var border = "_a-7";
export var brand = "_a-r";
export var button = "_a-j";
export var center = "_a-9";
export var centered = "_a-5";
export var closeButton = "_a-b";
export var disabledWrapper = "_a-k";
export var error = "_a-n";
export var extraLarge = "_a-4";
export var extraSmall = "_a-1";
export var fill = "_a-g";
export var footer = "_a-f";
export var footerAction = "_a-h";
export var footerButtons = "_a-i";
export var header = "_a-6";
export var icon = "_a-m";
export var info = "_a-q";
export var inline = "_a-8";
export var large = "_a-3";
export var main = "_a-c";
export var modal = "_a-0";
export var neutral = "_a-s";
export var noPadding = "_a-e";
export var none = "_a-t";
export var scrollable = "_a-d";
export var small = "_a-2";
export var success = "_a-p";
export var tight = "_a-l";
export var titleIcon = "_a-a";
export var warn = "_a-o";